jQuery(document).ready(function($) {
	ScrollTrigger.create({
		trigger: "#intro",
		start: "top 80%",
		// end: "top 30%",
		onEnter: () => $("#intro .cell").addClass("animated"),
		onLeaveBack: () => $("#intro .cell").removeClass("animated")
	});
	
	ScrollTrigger.create({
		trigger: "#featured",
		start: "top 80%",
		// end: "top 30%",
		onEnter: () => $("#featured h2").addClass("animated"),
		onLeaveBack: () => $("#featured h2").removeClass("animated")
	});
	
	$("#featured .featured__item").each(function() {
		ScrollTrigger.create({
			trigger: this,
			start: "top 80%",
			end: "bottom top",
			onEnter: () => $(this).addClass('active').removeClass('inactive'),
			// onLeave: () => $(this).addClass('inactive').removeClass('active'),
			// onEnterBack: () => $(this).addClass('active').removeClass('inactive'),
			onLeaveBack: () => $(this).addClass('inactive').removeClass('active'),
		});
	});
});